import Swiper from 'swiper';
import { Autoplay, Navigation, Zoom  } from 'swiper/modules';
Swiper.use([Autoplay, Navigation, Zoom]);
const top_newsCont = document.querySelectorAll('.lower__recruit__block__cont');

const top_newsBtm = document.querySelectorAll('.lower__recruit__block__tab button');
const top_newsBtmArr = Array.prototype.slice.call(top_newsBtm);


const hash = location.hash;

if (hash != null && hash == '#welfare') {
	top_newsCont.forEach(target => {
		target.classList.remove('active');
	});
	top_newsBtm.forEach(target => {
		target.classList.remove('active');
	});
	top_newsBtm[1].classList.add('active');
	top_newsCont[1].classList.add('active');
}

window.addEventListener("load", (event) => {
	const slider4 = new Swiper('.photo__slide--wrapper', {
		spaceBetween: 12,
		slidesPerView: 1,
		centeredSlides: true,
		zoom: true,
		loop: true,
		navigation: {
			nextEl: ".member-button-next",
			prevEl: ".member-button-prev",
		},
		breakpoints: {
			// スライドの表示枚数：500px以上の場合
			599: {
				spaceBetween: 24,
			},
			1024: {
				slidesPerView: "auto",
				spaceBetween: 24,
			}
		}
	});
	//
	slider4.autoplay.stop();
	//
	const slideObserver4 = new IntersectionObserver((entries) => {
		if (entries[0].isIntersecting) {
			//slider4.autoplay.start();
		}
	}, {
		rootMargin: '0px 0px -20% 0px',
	});
	slideObserver4.observe( document.querySelector('.photo__slide--wrapper') );

	top_newsBtm.forEach(element => {
		element.addEventListener('click', e => {
			top_newsCont.forEach(target => {
				target.classList.remove('active');
			});
			top_newsBtm.forEach(target => {
				target.classList.remove('active');
			});

			var index = top_newsBtmArr.indexOf(element);

			top_newsBtm[index].classList.add('active');
			top_newsCont[index].classList.add('active');

		});
	});
});
